import clsx from 'clsx';
import { FilterContentPopper } from '../FilterContent/FilterContentPopper';
import { FilterTypeRegistry } from '../FilterTypeRegistry';
import { FilterContentFieldDataTypes } from '../constants';
import { AppliedFilters, Filter, SelectedValueType } from '../interface';
import styles from './FiltersPopper.module.scss';

export interface FilterContentWrapperProps {
  filter: Filter;
  appliedFilters: AppliedFilters;
  onFilterChange: ({ filterKey, value }: { filterKey: string; value: unknown }) => void;
  clearFilter: (filterKey: string) => void;
}

export function FilterContentWrapper({
  filter,
  onFilterChange,
  appliedFilters,
  clearFilter
}: FilterContentWrapperProps) {
  const { filterKey, title, FilterContentComponent, filterContentProps, filterType } = filter;

  const {
    component: FilterComponent,
    ...restFilterComponentProps
  }: {
    component: React.FC<{ value: SelectedValueType; [key: string]: unknown }>;
    [key: string]: unknown;
  } = FilterTypeRegistry[filterType] as {
    component: React.FC<{ value: SelectedValueType; [key: string]: unknown }>;
    [key: string]: unknown;
  };

  const selectedValue =
    filterType === FilterContentFieldDataTypes.LIST
      ? appliedFilters[filterKey]?.value
      : appliedFilters[filterKey];

  return (
    <FilterContentPopper
      className={clsx('py-2', {
        [styles.filterContentPopperDateType]: filterType === FilterContentFieldDataTypes.DATE,
        [styles.filterContentPopper]: filterType !== FilterContentFieldDataTypes.DATE
      })}
      clearFilter={() => clearFilter(filterKey)}
      target={`#${filterKey}`}
      open={!!filterKey}
      title={title}
    >
      {FilterContentComponent ? (
        <FilterContentComponent
          {...filterContentProps}
          value={selectedValue}
          onChange={(_value: unknown) => onFilterChange({ filterKey, value: _value })}
        />
      ) : (
        <FilterComponent
          filterDataType={filterType}
          {...restFilterComponentProps}
          {...filterContentProps}
          value={selectedValue as SelectedValueType}
          onChange={(value: unknown) => onFilterChange({ filterKey, value })}
        />
      )}
    </FilterContentPopper>
  );
}
